import React from 'react';
import { twMerge } from 'tailwind-merge';
interface FitBadgeProps {
  score: number;
  className?: string;
  onPhoto?: boolean;
}
export function FitBadge({
  score,
  className,
  onPhoto = true
}: FitBadgeProps) {
  return <span className={twMerge('tabular inline-flex h-8 items-center gap-1.5 whitespace-nowrap rounded-full px-3 text-[13px] font-bold', onPhoto ? 'bg-black/60 text-white backdrop-blur-md' : 'bg-surface-2 text-ink', className)} data-id="element-788" data-mp="3odhhv76kvmnb">
      <span className="h-2 w-2 rounded-full bg-accent" aria-hidden="true" data-id="element-789" data-mp="684d175rlp40" />
      {score}% fit
    </span>;
}